import {KTSVG} from '../../../_metronic/helpers'
import {FC, useEffect, useState, forwardRef, useImperativeHandle} from 'react'

import {
  useAllpaymenttypes,
  useAllcustomers,
  useUpdatesalesinvoices,
  useCreateCustomerPayment,
} from '../../contextProviders/Atomqueryprovider'
import dayjs from 'dayjs'
import {useQueryClient} from 'react-query'

import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import {useSelectStyles} from '../../helpers/useSelectStyles'

type Props = {
  invoiceupdate: any
  invoiceData: any
  show: boolean
  handleClose: () => void
  ref: any
}

const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const API_URL = process.env.REACT_APP_API_URL

const addCommas = (num: any) => {
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(numValue)) {
    return '0'
  }
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const Updateinvoice: FC<Props> = forwardRef((props: Props, ref) => {
  const queryClient = useQueryClient()
  const [updatesmade, setUpdatesmade] = useState(true)

  // customer id and payment type
  const [customer_id, setCustomer_id] = useState<any>(null)
  const [payment_type_id, setPayment_type_id] = useState<any>(null)
  const [splitpayment, setSplitpayment] = useState<any>([])
  const [jointmpesacashPayment, setJointmpesacashPayment] = useState(false)
  const [jointmpesatipPayment, setJointmpesatipPayment] = useState(false)
  const [paymentstatuschange, setPaymentstatuschange] = useState<any>(null)
  const [newSetpriceMpesa, setNewSetpriceMpesa] = useState<number>(0)
  const [newSetpriceCash, setNewSetpriceCash] = useState<number>(0)
  const [newSetpriceTip, setNewSetpriceTip] = useState<number>(0)
  const [submitupdate, setSubmitupdate] = useState(false)
  const [amountPaidNow, setAmountPaidNow] = useState<number>(0)

  const {
    isLoading: allpaymenttypesloading,
    isSuccess: allpaymenttypessuccess,
    data: allpaymenttypesdata,
  } = useAllpaymenttypes()

  const {
    isLoading: allcustomersloading,
    isSuccess: allcustomerssuccess,
    data: allcustomersdata,
  } = useAllcustomers()

  let customeroptions =
    allcustomerssuccess &&
    allcustomersdata?.data.map((val: any) => ({
      value: val.customer_id,
      label: val.customer_firstname + ' ' + val.customer_secondname,
    }))

  let paymentoptions =
    allpaymenttypessuccess &&
    allpaymenttypesdata?.data.map((val: any) => ({
      value: val.payment_type_id,
      label: val.payment_type_name,
    }))

  let paymentstatus = [
    {value: 'PAID', label: 'PAID'},
    {value: 'NOT PAID', label: 'NOT PAID'},
    {value: 'CREDIT', label: 'CREDIT'},
    {value: 'PARTIAL', label: 'PARTIAL'},
  ]

  const handlepaymentChange = (e: any) => {
    if (e != null) {
      setPayment_type_id(e.value)
      if (e.label === 'MPESACASH') {
        setJointmpesacashPayment(true)
        setJointmpesatipPayment(false)
        setNewSetpriceMpesa(0)
        setNewSetpriceCash(0)
        setSplitpayment([])
      } else if (e.label === 'MPESATIP') {
        setJointmpesatipPayment(true)
        setJointmpesacashPayment(false)
        setNewSetpriceMpesa(Number(props.invoiceupdate.total_amount))
        setNewSetpriceTip(0)
        setSplitpayment([
          {total_amount: Number(props.invoiceupdate.total_amount), payment_type_name: 'MPESA'},
          {total_amount: 0, payment_type_name: 'TIP'},
        ])
      } else {
        setJointmpesacashPayment(false)
        setJointmpesatipPayment(false)
        setSplitpayment([
          {total_amount: Number(props.invoiceupdate.total_amount), payment_type_name: e.label},
        ])
      }
    }
  }

  const handlepaidstatusChange = (e: any) => {
    if (e != null) {
      setPaymentstatuschange(e.value)
    }
  }

  const handlepricechangeMpesa = (e: any) => {
    setNewSetpriceMpesa(Number(e.target.value))
    if (jointmpesacashPayment) {
      setSplitpayment([
        {total_amount: Number(e.target.value), payment_type_name: 'MPESA'},
        {total_amount: Number(newSetpriceCash), payment_type_name: 'CASH'},
      ])
    } else if (jointmpesatipPayment) {
      setSplitpayment([
        {total_amount: Number(e.target.value), payment_type_name: 'MPESA'},
        {total_amount: Number(newSetpriceTip), payment_type_name: 'TIP'},
      ])
    }
  }

  const handlepricechangeCash = (e: any) => {
    setNewSetpriceCash(Number(e.target.value))
    setSplitpayment([
      {total_amount: Number(newSetpriceMpesa), payment_type_name: 'MPESA'},
      {total_amount: Number(e.target.value), payment_type_name: 'CASH'},
    ])
  }

  const handlepricechangeTip = (e: any) => {
    setNewSetpriceTip(Number(e.target.value))
    setSplitpayment([
      {total_amount: Number(newSetpriceMpesa), payment_type_name: 'MPESA'},
      {total_amount: Number(e.target.value), payment_type_name: 'TIP'},
    ])
  }

  const handlecustomerChange = (e: any) => {
    if (e != null) {
      setCustomer_id(e.value)
    }
  }

  useImperativeHandle(ref, () => ({
    Resetmodalupdatevalues() {
      setCustomer_id(null)
      setPayment_type_id(null)
      setPaymentstatuschange(null)
      setSubmitupdate(false)
      setUpdatesmade(true)
      setJointmpesacashPayment(false)
      setJointmpesatipPayment(false)
      setSplitpayment([])
      setNewSetpriceCash(0)
      setNewSetpriceMpesa(0)
      setNewSetpriceTip(0)
      setAmountPaidNow(0)
    },
  }))

  const itemstoupdate: any = [
    {
      customer_id: customer_id != null ? customer_id : props.invoiceupdate.customer_id,
      payment_type_id:
        payment_type_id != null ? payment_type_id : props.invoiceupdate.payment_type_id,
      invoice_id: props.invoiceupdate.invoice_id,
      status: paymentstatuschange != null ? paymentstatuschange : props.invoiceupdate.status,
      split_payment: splitpayment,
      amount_paid_now: amountPaidNow,
    },
  ]

  const {mutateAsync: updateinvoicesalesmutateAsync} = useUpdatesalesinvoices(itemstoupdate)
  const {mutateAsync: createCustomerPaymentAsync} = useCreateCustomerPayment()

  const updatecurrentInvoice = async () => {
    setSubmitupdate(true)

    const prevStatus = props.invoiceupdate.status
    const newStatus = paymentstatuschange != null ? paymentstatuschange : prevStatus
    const isDebtPayment =
      dayjs(props.invoiceupdate.date_recorded).isBefore(dayjs(), 'day') &&
      (prevStatus === 'NOT PAID' || prevStatus === 'CREDIT' || prevStatus === 'PARTIAL') &&
      (newStatus === 'PAID' || newStatus === 'PARTIAL')

    let debtAmount = 0
    if (isDebtPayment) {
      if (newStatus === 'PARTIAL') {
        debtAmount = amountPaidNow
      } else {
        const alreadyPaid =
          prevStatus === 'PARTIAL' ? Number(props.invoiceupdate.amount_tendered || 0) : 0
        debtAmount = Number(props.invoiceupdate.total_amount) - alreadyPaid
      }
    }

    updateinvoicesalesmutateAsync(itemstoupdate, {
      onSuccess: async () => {
        if (isDebtPayment && debtAmount > 0) {
          try {
            await createCustomerPaymentAsync({
              invoice_id: props.invoiceupdate.invoice_id,
              customer_id: customer_id != null ? customer_id : props.invoiceupdate.customer_id,
              amount: debtAmount,
              payment_type_name: 'Debt Payment',
              user_id: props.invoiceupdate.user_id,
            })
            // Invalidate daily sales cache so the sales page reflects the new debt payment
            queryClient.invalidateQueries('dailysalesusequery')
            queryClient.invalidateQueries('dailysalesusequery2')
          } catch (err) {
            console.log('Failed to record debt payment', err)
          }
        }
        setSubmitupdate(false)
        props.handleClose()
      },
      onError(error) {
        console.log(error)
        setSubmitupdate(false)
        props.handleClose()
      },
    })
  }

  useEffect(() => {
    if (paymentstatuschange === 'PARTIAL' && customer_id && payment_type_id) {
      const actualPaidSoFar =
        props.invoiceupdate.status === 'NOT PAID' || props.invoiceupdate.status === 'CREDIT'
          ? 0
          : Number(props.invoiceupdate.amount_tendered || 0)
      const balanceDue = Number(props.invoiceupdate.total_amount) - actualPaidSoFar

      if (amountPaidNow > 0 && amountPaidNow <= balanceDue) {
        setUpdatesmade(false)
      } else if (
        amountPaidNow === 0 &&
        (customer_id !== props.invoiceupdate.customer_id ||
          paymentstatuschange !== props.invoiceupdate.status ||
          payment_type_id !== props.invoiceupdate.payment_type_id)
      ) {
        setUpdatesmade(false)
      } else {
        setUpdatesmade(true)
      }
      return
    }

    if (
      !jointmpesacashPayment &&
      !jointmpesatipPayment &&
      customer_id &&
      paymentstatuschange &&
      payment_type_id
    ) {
      if (
        customer_id !== props.invoiceupdate.customer_id ||
        paymentstatuschange !== props.invoiceupdate.status ||
        payment_type_id !== props.invoiceupdate.payment_type_id
      ) {
        setUpdatesmade(false)
      } else {
        setUpdatesmade(true)
      }
    }

    if (
      jointmpesacashPayment &&
      customer_id &&
      paymentstatuschange &&
      payment_type_id &&
      newSetpriceCash &&
      newSetpriceMpesa
    ) {
      if (
        customer_id !== props.invoiceupdate.customer_id ||
        paymentstatuschange !== props.invoiceupdate.status ||
        payment_type_id !== props.invoiceupdate.payment_type_id ||
        newSetpriceMpesa !==
          Number(
            props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'MPESA')
              ?.total_amount || 0
          ) ||
        newSetpriceCash !==
          Number(
            props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'CASH')
              ?.total_amount || 0
          )
      ) {
        if (
          Number(props.invoiceupdate.total_amount) ===
          Number(newSetpriceCash) + Number(newSetpriceMpesa)
        ) {
          setUpdatesmade(false)
        } else {
          setUpdatesmade(true)
        }
      } else {
        setUpdatesmade(true)
      }
    }

    if (
      jointmpesatipPayment &&
      customer_id &&
      paymentstatuschange &&
      payment_type_id &&
      newSetpriceTip !== undefined &&
      newSetpriceMpesa
    ) {
      if (
        customer_id !== props.invoiceupdate.customer_id ||
        paymentstatuschange !== props.invoiceupdate.status ||
        payment_type_id !== props.invoiceupdate.payment_type_id ||
        newSetpriceMpesa !==
          Number(
            props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'MPESA')
              ?.total_amount || 0
          ) ||
        newSetpriceTip !==
          Number(
            props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'TIP')
              ?.total_amount || 0
          )
      ) {
        if (newSetpriceTip > 0) {
          setUpdatesmade(false)
        } else {
          setUpdatesmade(true)
        }
      } else {
        setUpdatesmade(true)
      }
    }
  }, [
    customer_id,
    paymentstatuschange,
    payment_type_id,
    newSetpriceCash,
    newSetpriceMpesa,
    newSetpriceTip,
    amountPaidNow,
    props.invoiceupdate,
  ])

  useEffect(() => {
    setCustomer_id(props.invoiceupdate.customer_id)
    setPaymentstatuschange(props.invoiceupdate.status)
    setPayment_type_id(props.invoiceupdate.payment_type_id)

    if (props.invoiceupdate.payment_type_name === 'MPESACASH') {
      setJointmpesacashPayment(true)
      setJointmpesatipPayment(false)
      setNewSetpriceMpesa(
        Number(
          props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'MPESA')
            ?.total_amount || 0
        )
      )
      setNewSetpriceCash(
        Number(
          props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'CASH')
            ?.total_amount || 0
        )
      )
      setSplitpayment([
        {
          total_amount: Number(
            props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'MPESA')
              ?.total_amount || 0
          ),
          payment_type_name: 'MPESA',
        },
        {
          total_amount: Number(
            props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'CASH')
              ?.total_amount || 0
          ),
          payment_type_name: 'CASH',
        },
      ])
    } else if (props.invoiceupdate.payment_type_name === 'MPESATIP') {
      setJointmpesatipPayment(true)
      setJointmpesacashPayment(false)
      setNewSetpriceMpesa(Number(props.invoiceupdate.total_amount))
      setNewSetpriceTip(
        Number(
          props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'TIP')
            ?.total_amount || 0
        )
      )
      setSplitpayment([
        {total_amount: Number(props.invoiceupdate.total_amount), payment_type_name: 'MPESA'},
        {
          total_amount: Number(
            props.invoiceupdate.split_payment?.find((x: any) => x.payment_type_name === 'TIP')
              ?.total_amount || 0
          ),
          payment_type_name: 'TIP',
        },
      ])
    } else {
      setJointmpesacashPayment(false)
      setJointmpesatipPayment(false)
      setSplitpayment([
        {
          total_amount: props.invoiceupdate.total_amount,
          payment_type_name: props.invoiceupdate.payment_type_name,
        },
      ])
    }
  }, [props.show, props.invoiceupdate])

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>
            Update Invoice
            <span className='h-10px border-gray-200 border-start mx-2'></span>
            <span className='text-muted fw-bold fs-6'>{props.invoiceupdate.invoice_id}</span>
          </h3>
          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form className='form' noValidate>
            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                <label className='required fw-bold fs-6 mb-2'>Total</label>
                <div>
                  <span className='text-muted fw-bold fs-6'>
                    {addCommas(Number(props.invoiceupdate.total_amount).toFixed(2))} {CURRENCY_APP}
                  </span>
                </div>
              </div>
              <div className='col-lg-6 fv-row mb-7'>
                <label
                  className='required fw-bold fs-6 mb-2'
                  style={{display: jointmpesacashPayment ? 'block' : 'none'}}
                >
                  Split Amount
                </label>
                <div style={{display: jointmpesacashPayment ? 'block' : 'none'}}>
                  <span className='fw-bold fs-6 text-primary'>
                    {jointmpesacashPayment &&
                      addCommas(
                        Number(Number(newSetpriceCash) + Number(newSetpriceMpesa)).toFixed(2)
                      )}{' '}
                    {CURRENCY_APP}
                  </span>
                </div>
              </div>
            </div>

            <div className='fv-row mb-7'>
              <label className='required fw-bold fs-6 mb-2'>Customer</label>
              <Select
                options={customeroptions || []}
                styles={useSelectStyles()}
                isDisabled={true}
                isLoading={allcustomersloading}
                value={
                  customeroptions &&
                  customeroptions.filter(
                    (x: any) => x.value == (customer_id || props.invoiceupdate.customer_id)
                  )
                }
                placeholder={'Select customer ...'}
                isSearchable={true}
                onChange={(e: any) => handlecustomerChange(e)}
              />
            </div>

            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                <label className='required fw-bold fs-6 mb-2'>Payment Status</label>
                <Select
                  options={paymentstatus}
                  styles={useSelectStyles()}
                  isDisabled={false}
                  defaultValue={paymentstatus.filter(
                    (x: any) => x.value == props.invoiceupdate.status
                  )}
                  placeholder={'Select payment status ...'}
                  isSearchable={true}
                  onChange={(e: any) => handlepaidstatusChange(e)}
                />
              </div>
              <div className='col-lg-6 fv-row mb-7'>
                <label className='required fw-bold fs-6 mb-2'>Payment Mode</label>
                <Select
                  options={paymentoptions || []}
                  styles={useSelectStyles()}
                  isDisabled={false}
                  isLoading={allpaymenttypesloading}
                  defaultValue={
                    paymentoptions &&
                    paymentoptions.filter(
                      (x: any) => x.value == props.invoiceupdate.payment_type_id
                    )
                  }
                  placeholder={'Select payment mode ...'}
                  isSearchable={true}
                  onChange={(e: any) => handlepaymentChange(e)}
                />
              </div>
            </div>

            {paymentstatuschange === 'PARTIAL' && (
              <div className='row'>
                <div className='col-lg-6 fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Balance Due</label>
                  <div>
                    <span className='text-danger fw-bold fs-6'>
                      {(() => {
                        const actualPaidSoFar =
                          props.invoiceupdate.status === 'NOT PAID' ||
                          props.invoiceupdate.status === 'CREDIT'
                            ? 0
                            : Number(props.invoiceupdate.amount_tendered || 0)
                        return addCommas(
                          (Number(props.invoiceupdate.total_amount) - actualPaidSoFar).toFixed(2)
                        )
                      })()}{' '}
                      {CURRENCY_APP}
                    </span>
                  </div>
                </div>
                <div className='col-lg-6 fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Amount Paying Now</label>
                  <input
                    placeholder='0.00'
                    min='0'
                    step='.01'
                    className='form-control form-control-lg form-control-solid'
                    type='number'
                    autoComplete='off'
                    value={amountPaidNow}
                    onChange={(e) => setAmountPaidNow(Number(e.target.value))}
                  />
                  {amountPaidNow > 0 && (
                    <div className='mt-2'>
                      <span className='text-muted fw-bold fs-7'>
                        New Balance:{' '}
                        {(() => {
                          const actualPaidSoFar =
                            props.invoiceupdate.status === 'NOT PAID' ||
                            props.invoiceupdate.status === 'CREDIT'
                              ? 0
                              : Number(props.invoiceupdate.amount_tendered || 0)
                          return addCommas(
                            (
                              Number(props.invoiceupdate.total_amount) -
                              actualPaidSoFar -
                              amountPaidNow
                            ).toFixed(2)
                          )
                        })()}{' '}
                        {CURRENCY_APP}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className='row'>
              <div
                className='col-lg-6 fv-row mb-7'
                style={{display: jointmpesacashPayment ? 'block' : 'none'}}
              >
                <label className='required fw-bold fs-6 mb-2'>MPESA</label>
                <input
                  placeholder='0.00'
                  min='0'
                  step='.01'
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  autoComplete='off'
                  value={parseFloat(newSetpriceMpesa.toString()).toFixed(2)}
                  onChange={(e) => handlepricechangeMpesa(e)}
                />
              </div>
              <div
                className='col-lg-6 fv-row mb-7'
                style={{display: jointmpesacashPayment ? 'block' : 'none'}}
              >
                <label className='required fw-bold fs-6 mb-2'>CASH</label>
                <input
                  min='0'
                  step='.01'
                  placeholder='0.00'
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  autoComplete='off'
                  value={parseFloat(newSetpriceCash.toString()).toFixed(2)}
                  onChange={(e) => handlepricechangeCash(e)}
                />
              </div>
            </div>

            <div className='row'>
              <div
                className='col-lg-6 fv-row mb-7'
                style={{display: jointmpesatipPayment ? 'block' : 'none'}}
              >
                <label className='required fw-bold fs-6 mb-2'>MPESA</label>
                <input
                  placeholder='0.00'
                  min='0'
                  step='.01'
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  autoComplete='off'
                  value={parseFloat(newSetpriceMpesa.toString()).toFixed(2)}
                  onChange={(e) => handlepricechangeMpesa(e)}
                  disabled={true}
                />
              </div>
              <div
                className='col-lg-6 fv-row mb-7'
                style={{display: jointmpesatipPayment ? 'block' : 'none'}}
              >
                <label className='required fw-bold fs-6 mb-2'>TIP AMOUNT</label>
                <input
                  min='0'
                  step='.01'
                  placeholder='0.00'
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  autoComplete='off'
                  value={parseFloat(newSetpriceTip.toString()).toFixed(2)}
                  onChange={(e) => handlepricechangeTip(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-info'
            onClick={updatecurrentInvoice}
            disabled={updatesmade}
          >
            {!submitupdate && <span className='indicator-label'>Update Invoice</span>}
            {submitupdate && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})
